import React from 'react';
import { number, string } from 'prop-types';
import styled from 'styled-components';
import Balance from './BalanceContainer';

const Container = styled.div`
  font-size: 16px;
  margin: 24px 10px 0 10px;
  text-align: center;
  color: #4a4a4a;
  line-height: 1.4;

  @media(min-width: 1000px) {
    font-size: 20px;
    flex-direction: row;
    margin: 8px 10px 0 10px;
  }
`;

const BalanceWrapper = props => (
  <Container>
    <Balance {...props} />
  </Container>
);

BalanceWrapper.propTypes = {
  balance: number,
  text: string,
};

BalanceWrapper.defaultProps = {
  balance: 0,
  text: null,
};

export default BalanceWrapper;
